import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { popupMessages } from '../data/buyers';
import { OFFER_ANCHOR, PRODUCT } from '../data/constants';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const showTimer = window.setTimeout(() => setVisible(true), 4000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      timeout = window.setTimeout(() => {
        setIndex(i => (i + 1) % popupMessages.length);
        setVisible(true);
      }, 700);
    }, 11000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearInterval(cycle);
      window.clearTimeout(timeout);
    };
  }, [dismissed]);
  const message = popupMessages[index];
  const offset = reduceMotion ? 0 : -24;
  return <AnimatePresence data-id="element-156" data-mp="163mmv4aozswm">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      x: offset,
      scale: reduceMotion ? 1 : 0.97
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: offset,
      scale: reduceMotion ? 1 : 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-2.5 left-2.5 z-50 w-[250px] max-w-[calc(100vw-20px)] sm:bottom-5 sm:left-5 sm:w-[290px]" role="status" aria-live="polite" data-id="element-157" data-mp="1164no5mh8s1t">
          <div className="relative rounded-xl border-[3px] border-tech bg-gold p-2.5 pr-7 shadow-xl ring-2 ring-navy" data-id="element-158" data-mp="x5krb49q9sgq">
            <button type="button" onClick={() => setDismissed(true)} aria-label="Fermer la notification" className="absolute right-1 top-1 rounded p-1 text-navy transition-colors duration-150 ease-out hover:text-tech-dark" data-id="element-159" data-mp="s5eul9olpfrs">
              <XIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-160" data-mp="2anjkljjmyf9e" />
            </button>
            <a href={OFFER_ANCHOR} className="flex items-start gap-2" data-id="element-161" data-mp="2fmv2ivvqnqsk">
              <span className="mt-0.5 text-lg leading-none" aria-hidden="true" data-id="element-162" data-mp="2kmr6ww8clk8n">
                {message.icon}
              </span>
              <div className="min-w-0" data-id="element-163" data-mp="2pm3trgz7yrb8">
                <p className="font-display text-sm font-extrabold leading-tight text-navy" data-id="element-164" data-mp="2pl2e0z79dgn6">
                  {message.title}
                </p>
                <p className="mt-0.5 truncate font-display text-2xs font-bold uppercase tracking-wide text-navy" data-id="element-165" data-mp="1wwn58uepzuka">
                  {PRODUCT}
                </p>
                <p className="mt-0.5 text-2xs font-semibold text-navy" data-id="element-166" data-mp="21u6k9wj8sbda">{message.detail}</p>
              </div>
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}